var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-sm-12" }, [
    _c(
      "div",
      { staticClass: "container-fluid scoped-main-subquestions-container" },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.readonly,
                expression: "!readonly"
              }
            ],
            staticClass: "row"
          },
          [
            !_vm.isSurveyActive
              ? _c("div", { staticClass: "col-sm-8" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-default col-3",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.openQuickAdd()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm._f("translate")("Quick add")))]
                  )
                ])
              : _vm._e(),
            !_vm.isSurveyActive
              ? _c("div", { staticClass: "col-sm-4 text-right" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-danger col-5",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.resetSubquestions()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm._f("translate")("Reset")))]
                  )
                ])
              : _vm._e()
          ]
        ),
        _vm._m(0),
        _vm._l(_vm.subquestionScales, function(subquestionscale) {
          return [
            subquestionscale == 0
              ? _c(
                  "div",
                  { key: subquestionscale, staticClass: "panel panel-default" },
                  [
                    _c("div", { staticClass: "panel-heading" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm._f("translate")("Y-Scale (lines)")) +
                          "\n                    "
                      )
                    ]),
                    _c("div", { staticClass: "panel-body" }, [
                      _c(
                        "div",
                        {
                          key: subquestionscale + "subquestions",
                          staticClass:
                            "row list-group scoped-subquestion-row-container",
                          on: {
                            dragover: function($event) {
                              $event.preventDefault()
                              return _vm.preventDisallowedCursor($event)
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "list-group-item scoped-subquestion-block header-block"
                            },
                            [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.readonly,
                                      expression: "!readonly"
                                    }
                                  ],
                                  staticClass: "scoped-move-block"
                                },
                                [_c("div", [_vm._v(" ")])]
                              ),
                              _c("div", { staticClass: "scoped-code-block" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm._f("translate")("Title")) +
                                    "\n                            "
                                )
                              ]),
                              _c(
                                "div",
                                { staticClass: "scoped-content-block" },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm._f("translate")("Subquestion")
                                      ) +
                                      "\n                            "
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "scoped-relevance-block" },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s("Condition") +
                                      "\n                            "
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.readonly,
                                      expression: "!readonly"
                                    }
                                  ],
                                  staticClass: "scoped-actions-block"
                                },
                                [_c("div", [_vm._v(" ")])]
                              )
                            ]
                          ),
                          _vm._l(_vm.currentDataSet[subquestionscale], function(
                            subquestion
                          ) {
                            return _c(
                              "div",
                              {
                                key: subquestion.qid,
                                staticClass:
                                  "list-group-item scoped-subquestion-block",
                                class: _vm.subQuestionDragging
                                  ? "movement-active" +
                                    (subquestion.qid ==
                                    _vm.draggedSubQuestion.qid
                                      ? " in-movement"
                                      : "")
                                  : "",
                                on: {
                                  dragenter: function($event) {
                                    $event.preventDefault()
                                    return _vm.dragoverSubQuestion(
                                      $event,
                                      subquestion,
                                      subquestionscale
                                    )
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.readonly,
                                        expression: "!readonly"
                                      }
                                    ],
                                    staticClass: "scoped-move-block"
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-bars",
                                      class: _vm.surveyActive
                                        ? " disabled"
                                        : " ",
                                      attrs: { draggable: !_vm.surveyActive },
                                      on: {
                                        dragstart: function($event) {
                                          return _vm.startDraggingSubQuestion(
                                            $event,
                                            subquestion,
                                            subquestionscale
                                          )
                                        },
                                        dragend: function($event) {
                                          return _vm.endDraggingSubQuestion(
                                            $event,
                                            subquestion,
                                            subquestionscale
                                          )
                                        }
                                      }
                                    })
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "scoped-code-block   " },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: subquestion.title,
                                          expression: "subquestion.title"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      class: _vm.surveyActive
                                        ? " disabled"
                                        : " ",
                                      attrs: {
                                        type: "text",
                                        maxlength: "20",
                                        size: "5",
                                        disabled: _vm.surveyActive,
                                        name:
                                          "code_" +
                                          subquestion.question_order +
                                          "_" +
                                          subquestionscale,
                                        readonly: _vm.readonly
                                      },
                                      domProps: { value: subquestion.title },
                                      on: {
                                        dblclick: _vm.toggleEditMode,
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          $event.preventDefault()
                                          return _vm.switchinput(
                                            "answer_" +
                                              _vm.$store.state.activeLanguage +
                                              "_" +
                                              subquestion.qid +
                                              "_" +
                                              subquestionscale
                                          )
                                        },
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            subquestion,
                                            "title",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "scoped-content-block   " },
                                  [
                                    _c("input", {
                                      staticClass: "answer form-control input",
                                      attrs: {
                                        type: "text",
                                        size: "20",
                                        id:
                                          "answer_" +
                                          _vm.$store.state.activeLanguage +
                                          "_" +
                                          subquestion.qid +
                                          "_" +
                                          subquestionscale,
                                        name:
                                          "answer_" +
                                          _vm.$store.state.activeLanguage +
                                          "_" +
                                          subquestion.qid +
                                          "_" +
                                          subquestionscale,
                                        placeholder: _vm.translate(
                                          "Some example subquestion"
                                        ),
                                        readonly: _vm.readonly
                                      },
                                      domProps: {
                                        value: _vm.getQuestionForCurrentLanguage(
                                          subquestion
                                        )
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.setQuestionForCurrentLanguage(
                                            subquestion,
                                            $event,
                                            arguments
                                          )
                                        },
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          $event.preventDefault()
                                          return _vm.switchinput(
                                            "relevance_" +
                                              subquestion.qid +
                                              "_" +
                                              subquestionscale
                                          )
                                        },
                                        dblclick: _vm.toggleEditMode
                                      }
                                    })
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "scoped-relevance-block   " },
                                  [
                                    _c("div", { staticClass: "input-group" }, [
                                      _c(
                                        "div",
                                        { staticClass: "input-group-addon" },
                                        [_vm._v("{")]
                                      ),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: subquestion.relevance,
                                            expression: "subquestion.relevance"
                                          }
                                        ],
                                        staticClass:
                                          "relevance_input_field form-control input",
                                        attrs: {
                                          type: "text",
                                          id:
                                            "relevance_" +
                                            subquestion.qid +
                                            "_" +
                                            subquestionscale,
                                          name:
                                            "relevance_" +
                                            subquestion.qid +
                                            "_" +
                                            subquestionscale,
                                          readonly: _vm.readonly
                                        },
                                        domProps: {
                                          value: subquestion.relevance
                                        },
                                        on: {
                                          dblclick: _vm.toggleEditMode,
                                          keyup: function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            $event.preventDefault()
                                            return _vm.switchinput(
                                              false,
                                              $event
                                            )
                                          },
                                          focus: _vm.triggerScale,
                                          blur: _vm.untriggerScale,
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              subquestion,
                                              "relevance",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _c(
                                        "div",
                                        { staticClass: "input-group-addon" },
                                        [_vm._v("}")]
                                      )
                                    ])
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.readonly,
                                        expression: "!readonly"
                                      }
                                    ],
                                    staticClass: "scoped-actions-block"
                                  },
                                  [
                                    !_vm.surveyActive
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-default btn-small",
                                            attrs: {
                                              "data-toggle": "tooltip",
                                              title: _vm.translate("Delete")
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.deleteThisDataSet(
                                                  subquestion,
                                                  subquestionscale
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fa fa-trash text-danger"
                                            }),
                                            _c(
                                              "span",
                                              { staticClass: "sr-only" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("translate")(
                                                      "Delete"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-default btn-small",
                                        attrs: {
                                          "data-toggle": "tooltip",
                                          title: _vm.translate("Open editor")
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.openPopUpEditor(
                                              subquestion,
                                              subquestionscale
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("i", { staticClass: "fa fa-edit" }),
                                        _c("span", { staticClass: "sr-only" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("translate")("Open editor")
                                            )
                                          )
                                        ])
                                      ]
                                    ),
                                    !_vm.surveyActive
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-default btn-small",
                                            attrs: {
                                              "data-toggle": "tooltip",
                                              title: _vm.translate("Duplicate")
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.duplicateThisDataSet(
                                                  subquestion,
                                                  subquestionscale
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-copy"
                                            }),
                                            _c(
                                              "span",
                                              { staticClass: "sr-only" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("translate")(
                                                      "Duplicate"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]
                            )
                          })
                        ],
                        2
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.readonly,
                              expression: "!readonly"
                            }
                          ],
                          key: subquestionscale + "metaSettings",
                          staticClass: "row custom custom-margin bottom-15"
                        },
                        [
                          _c("div", { staticClass: "col-sm-6 text-left" }, [
                            !_vm.isSurveyActive
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-default",
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.openLabelSets(
                                          subquestionscale
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("translate")(
                                          "Predefined label sets"
                                        )
                                      )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-default",
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.saveAsLabelSet(subquestionscale)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("translate")("Save as label set")
                                  )
                                )
                              ]
                            )
                          ]),
                          _c("div", { staticClass: "col-sm-6 text-right" }, [
                            !_vm.surveyActive
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary",
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.addDataSet(subquestionscale)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", { staticClass: "fa fa-plus" }),
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm._f("translate")("Add subquestion")
                                        ) +
                                        "\n                            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        ]
                      )
                    ])
                  ]
                )
              : _vm._e(),
            subquestionscale == 1
              ? _c(
                  "div",
                  { key: subquestionscale, staticClass: "panel panel-default" },
                  [
                    _c("div", { staticClass: "panel-heading" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm._f("translate")("X-Scale (columns)")) +
                          "\n                "
                      )
                    ]),
                    _c("div", { staticClass: "panel-body" }, [
                      _c(
                        "div",
                        {
                          key: subquestionscale + "subquestions",
                          staticClass:
                            "row list-group scoped-subquestion-row-container",
                          on: {
                            dragover: function($event) {
                              $event.preventDefault()
                              return _vm.preventDisallowedCursor($event)
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "list-group-item scoped-subquestion-block header-block"
                            },
                            [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.readonly,
                                      expression: "!readonly"
                                    }
                                  ],
                                  staticClass: "scoped-move-block"
                                },
                                [_c("div", [_vm._v(" ")])]
                              ),
                              _c("div", { staticClass: "scoped-code-block" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm._f("translate")("Title")) +
                                    "\n                            "
                                )
                              ]),
                              _c(
                                "div",
                                { staticClass: "scoped-content-block" },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm._f("translate")("Subquestion")
                                      ) +
                                      "\n                            "
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "scoped-relevance-block" },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s("Condition") +
                                      "\n                            "
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.readonly,
                                      expression: "!readonly"
                                    }
                                  ],
                                  staticClass: "scoped-actions-block"
                                },
                                [_c("div", [_vm._v(" ")])]
                              )
                            ]
                          ),
                          _vm._l(_vm.currentDataSet[subquestionscale], function(
                            subquestion
                          ) {
                            return _c(
                              "div",
                              {
                                key: subquestion.qid,
                                staticClass:
                                  "list-group-item scoped-subquestion-block",
                                class: _vm.subQuestionDragging
                                  ? "movement-active" +
                                    (subquestion.qid ==
                                    _vm.draggedSubQuestion.qid
                                      ? " in-movement"
                                      : "")
                                  : "",
                                on: {
                                  dragenter: function($event) {
                                    $event.preventDefault()
                                    return _vm.dragoverSubQuestion(
                                      $event,
                                      subquestion,
                                      subquestionscale
                                    )
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.readonly,
                                        expression: "!readonly"
                                      }
                                    ],
                                    staticClass: "scoped-move-block"
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-bars",
                                      class: _vm.surveyActive
                                        ? " disabled"
                                        : " ",
                                      attrs: { draggable: !_vm.surveyActive },
                                      on: {
                                        dragstart: function($event) {
                                          return _vm.startDraggingSubQuestion(
                                            $event,
                                            subquestion,
                                            subquestionscale
                                          )
                                        },
                                        dragend: function($event) {
                                          return _vm.endDraggingSubQuestion(
                                            $event,
                                            subquestion,
                                            subquestionscale
                                          )
                                        }
                                      }
                                    })
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "scoped-code-block   " },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: subquestion.title,
                                          expression: "subquestion.title"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      class: _vm.surveyActive
                                        ? " disabled"
                                        : " ",
                                      attrs: {
                                        type: "text",
                                        maxlength: "20",
                                        size: "5",
                                        disabled: _vm.surveyActive,
                                        name:
                                          "code_" +
                                          subquestion.question_order +
                                          "_" +
                                          subquestionscale,
                                        readonly: _vm.readonly
                                      },
                                      domProps: { value: subquestion.title },
                                      on: {
                                        dblclick: _vm.toggleEditMode,
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          $event.preventDefault()
                                          return _vm.switchinput(
                                            "answer_" +
                                              _vm.$store.state.activeLanguage +
                                              "_" +
                                              subquestion.qid +
                                              "_" +
                                              subquestionscale
                                          )
                                        },
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            subquestion,
                                            "title",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "scoped-content-block   " },
                                  [
                                    _c("input", {
                                      staticClass: "answer form-control input",
                                      attrs: {
                                        type: "text",
                                        size: "20",
                                        id:
                                          "answer_" +
                                          _vm.$store.state.activeLanguage +
                                          "_" +
                                          subquestion.qid +
                                          "_" +
                                          subquestionscale,
                                        name:
                                          "answer_" +
                                          _vm.$store.state.activeLanguage +
                                          "_" +
                                          subquestion.qid +
                                          "_" +
                                          subquestionscale,
                                        placeholder: _vm.translate(
                                          "Some example subquestion"
                                        ),
                                        readonly: _vm.readonly
                                      },
                                      domProps: {
                                        value: _vm.getQuestionForCurrentLanguage(
                                          subquestion
                                        )
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.setQuestionForCurrentLanguage(
                                            subquestion,
                                            $event,
                                            arguments
                                          )
                                        },
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          $event.preventDefault()
                                          return _vm.switchinput(
                                            "relevance_" +
                                              subquestion.qid +
                                              "_" +
                                              subquestionscale
                                          )
                                        },
                                        dblclick: _vm.toggleEditMode
                                      }
                                    })
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "scoped-relevance-block   " },
                                  [
                                    _c("div", { staticClass: "input-group" }, [
                                      _c(
                                        "div",
                                        { staticClass: "input-group-addon" },
                                        [_vm._v("{")]
                                      ),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: subquestion.relevance,
                                            expression: "subquestion.relevance"
                                          }
                                        ],
                                        staticClass:
                                          "relevance_input_field form-control input",
                                        attrs: {
                                          type: "text",
                                          id:
                                            "relevance_" +
                                            subquestion.qid +
                                            "_" +
                                            subquestionscale,
                                          name:
                                            "relevance_" +
                                            subquestion.qid +
                                            "_" +
                                            subquestionscale,
                                          readonly: _vm.readonly
                                        },
                                        domProps: {
                                          value: subquestion.relevance
                                        },
                                        on: {
                                          dblclick: _vm.toggleEditMode,
                                          keyup: function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            $event.preventDefault()
                                            return _vm.switchinput(
                                              false,
                                              $event
                                            )
                                          },
                                          focus: _vm.triggerScale,
                                          blur: _vm.untriggerScale,
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              subquestion,
                                              "relevance",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _c(
                                        "div",
                                        { staticClass: "input-group-addon" },
                                        [_vm._v("}")]
                                      )
                                    ])
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.readonly,
                                        expression: "!readonly"
                                      }
                                    ],
                                    staticClass: "scoped-actions-block"
                                  },
                                  [
                                    !_vm.surveyActive
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-default btn-small",
                                            attrs: {
                                              "data-toggle": "tooltip",
                                              title: _vm.translate("Delete")
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.deleteThisDataSet(
                                                  subquestion,
                                                  subquestionscale
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fa fa-trash text-danger"
                                            }),
                                            _c(
                                              "span",
                                              { staticClass: "sr-only" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("translate")(
                                                      "Delete"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-default btn-small",
                                        attrs: {
                                          "data-toggle": "tooltip",
                                          title: _vm.translate("Open editor")
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.openPopUpEditor(
                                              subquestion,
                                              subquestionscale
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("i", { staticClass: "fa fa-edit" }),
                                        _c("span", { staticClass: "sr-only" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("translate")("Open editor")
                                            )
                                          )
                                        ])
                                      ]
                                    ),
                                    !_vm.surveyActive
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-default btn-small",
                                            attrs: {
                                              "data-toggle": "tooltip",
                                              title: _vm.translate("Duplicate")
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.duplicateThisDataSet(
                                                  subquestion,
                                                  subquestionscale
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-copy"
                                            }),
                                            _c(
                                              "span",
                                              { staticClass: "sr-only" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("translate")(
                                                      "Duplicate"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]
                            )
                          })
                        ],
                        2
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.readonly,
                              expression: "!readonly"
                            }
                          ],
                          key: subquestionscale + "metaSettings",
                          staticClass: "row custom custom-margin bottom-15"
                        },
                        [
                          _c("div", { staticClass: "col-sm-6 text-left" }, [
                            !_vm.isSurveyActive
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-default",
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.openLabelSets(
                                          subquestionscale
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("translate")(
                                          "Predefined label sets"
                                        )
                                      )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-default",
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.saveAsLabelSet(subquestionscale)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("translate")("Save as label set")
                                  )
                                )
                              ]
                            )
                          ]),
                          _c("div", { staticClass: "col-sm-6 text-right" }, [
                            !_vm.surveyActive
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary",
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.addDataSet(subquestionscale)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", { staticClass: "fa fa-plus" }),
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm._f("translate")("Add subquestion")
                                        ) +
                                        "\n                            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        ]
                      )
                    ])
                  ]
                )
              : _vm._e()
          ]
        })
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12" }, [_c("hr")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }